<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <el-button :size="size" icon="el-icon-search"  v-if="showButton('search')" @click="searchLogInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="logList"
        height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="opModules" label="操作模块" align="center"></el-table-column>
        <el-table-column prop="opDesc" label="操作描述" align="center"></el-table-column>
        <el-table-column prop="logIp" label="日志IP" align="center"></el-table-column>
        <el-table-column prop="logUrl" label="日志Url" align="center"></el-table-column>
        <el-table-column prop="opType" label="日志类型" align="center"></el-table-column>
        <el-table-column prop="userName" label="操作人" align="center"></el-table-column>
        <el-table-column prop="opTime" label="操作时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { changeSize } from '../../plugins/public'; // 动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        logList: [], // 日志列表信息
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchLogInfo(true);
    },
    methods: {
      // 查询日志信息
      searchLogInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.loading = true;
        this.$api.System.searchLogInfo(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.logList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchLogInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchLogInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>